import { createApp } from 'vue';
import store from './store';
	
import App from './app';

import './scss/index.scss'


class Main {
	constructor() {
		// make sure elements (and thus hooks in the page are rendered);
		this.htmlReady(() => {
			//load your component(s) async
			this.createComponent('#knd-app', App);
		})
	}

	createComponent(sel, comp) { 
		let el = document.querySelector(sel);
		if(!sel) return;

		this.setLoader(sel);

		const app = createApp(comp);

		app.config.globalProperties.processWireBase = process.env.VUE_APP_PBASE;

		store.dispatch('loadData').then( () => {
			app.use(store);
			app.mount(sel);
		});
	}

	setLoader(sel) {
		let el = document.querySelector(sel);

		if(el) {
			let div = document.createElement("div")
			div.classList.add('knd-loader');
			el.append(div);				
		}		
	}


	htmlReady(cb){
		// in case the document is already rendered
		if (document.readyState !== 'loading'){
			cb();
		}

		// modern browsers
		else if (document.addEventListener){ 
			document.addEventListener('DOMContentLoaded', cb);
		}
		// IE <= 8
		else document.attachEvent('onreadystatechange',() => {
			if (document.readyState=='complete') cb();
		});
	}
}

let main = new Main();
